import React, { useMemo } from 'react'
import { ButtonBase, ButtonBaseProps, TextProps, withLinkWrapper } from '.'
import { theme, ThemeColorKey } from 'theme'

interface ButtonSecondaryProps extends ButtonBaseProps {
    themeColor?: ThemeColorKey
}

const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
    themeColor = 'black',
    sx,
    textProps,
    children,
    ...props
}) => {
    const mergedSx = useMemo(
        () => ({
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: theme.colors[themeColor],
            '&:hover:not(:disabled)': {
                boxShadow: `inset 0 0 0 1px ${theme.colors[themeColor]}`,
            },
            ...sx,
        }),
        [sx],
    )
    const mergedtextProps = useMemo(
        () =>
            ({
                color: theme.colors[themeColor],
                fontWeight: 'normal',
                ...textProps,
            }) as TextProps,
        [textProps],
    )
    return (
        <ButtonBase bg={theme.newColors.neutral50} sx={mergedSx} textProps={mergedtextProps} {...props}>
            {children}
        </ButtonBase>
    )
}

export default ButtonSecondary
export const ButtonSecondaryLink = withLinkWrapper(ButtonSecondary)
